import axios from "@/plugins/axios/subCategoryApi";
import i18n from "@/plugins/i18n";

export default {
  GET_SUBCATEGORIES: async ({ commit, getters }, lang) => {
    commit("SET_ERROR", false);
    // commit('SET_LOADER', true)
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
        lang: lang ?? i18n.locale,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .get("allSubCategories", config)
        .then((response) => {
          commit("SET_LOADER", false);
          resolve(response.data.subCategories);
        })
        .catch((error) => {
          reject(error);
          commit("SET_LOADER", false);
          commit("SET_ERROR", true);
        });
    });
  },
  GET_SUBCATEGORY: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .get(`singleSubCategory/${payload}`, config)
        .then((response) => {
          commit("SET_LOADER", false);
          resolve(response.data.subcategory);
        })
        .catch((error) => {
          reject(error);
          commit("SET_LOADER", false);
          commit("SET_ERROR", true);
        });
    });
  },
  CREATE_SUBCATEGORY: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.post("createSubCategory", payload, config);
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message,
        type: "success",
      });
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message: error.response.data.message,
        type: "error",
      });
      console.log(error);
    }
  },
  UPDATE_SUBCATEGORY: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
        lang: payload.language,
      },
    };
    try {
      let response = await axios.put(
        `updateSubCategory/${payload.subcategory.id}`,
        payload.subcategory,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message,
        type: "success",
      });
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message: error.response.data.message,
        type: "error",
      });
      console.log(error);
    }
  },
  DELETE_SUBCATEGORY: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.delete(
        `deleteSubCategory/${payload.id}`,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message,
        type: "success",
      });
      console.log(response);
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message: error.response.data.message,
        type: "error",
      });
      console.log(error);
    }
  },
};
